module.exports = __webpack_public_path__ + "img/slider-rectangle-h.e6f18502.svg";